module.exports = __webpack_public_path__ + "static/media/nidhi_patel.b678db9e.jpg";